<template>
    <div class="vuetable-filterbar col-md-12">
	    <div class="form-group p-l">
            <b-container fluid class="p-a-0">
                <b-row no-gutters>
                    <b-col sm="6" md="2" class="p-a-0 m-t-5px" v-if='fieldDynamic'>
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input type="text" class="form-control" v-model="num_fiscal" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">N° Fatura</label>
                        </div>
                    </b-col>
                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input type="text" class="form-control" v-model="num_controle" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;" v-if='fieldDynamic'>N° Controle</label>
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;" v-if='!fieldDynamic'>N° Fatura</label>
                        </div>
                    </b-col>
                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input type="text" class="form-control" v-model="chave_cte" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Chave CTE</label>
                        </div>
                    </b-col>
                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input type="text" class="form-control" v-model="num_fiscal_cte" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">N° Fiscal CTE</label>
                        </div>
                    </b-col>
                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input type="text" class="form-control" v-model="tom_nome" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Nome Tomador</label>
                        </div>
                    </b-col>
                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input type="text" class="form-control" v-model="tom_cnpj" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">CNPJ Tomador</label>
                        </div>
                    </b-col>
                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input type="text" class="form-control" v-model="tom_ie" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Inscrição Estadual Tomador</label>
                        </div>
                    </b-col>
                    <b-col sm="6" md="1" class="m-t-5px p-a-0">
                        <div class="fl-flex-label fl-collapsed fl-background">
                          <input type="text" class="form-control" v-mask="'##/##/####'" v-model="dt_inicio" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Data Inicio Fatura</label>
                        </div>
                    </b-col>

                    <b-col sm="6" md="1" class="m-t-5px p-a-0">
                        <div class="fl-flex-label fl-collapsed fl-background">
                          <input type="text" class="form-control" v-mask="'##/##/####'" v-model="dt_fim" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Data Fim Fatura</label>
                        </div>
                    </b-col>

                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                        <multiselect v-model="status"
                        :options="optionsLivStatus"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Status"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col>
                    <b-col sm="6" md="2" class="m-t-5px">
                        <div class="input-group-btn">
                            <div class="btn-group">
                                <button type="button" class="btn btn-secondary btn-outline" @click="doFilter" :disabled="vuetableFilterButton">Filtrar</button>
                                <button type="button" class="btn btn-secondary btn-outline" @click="resetFilter" :disabled="vuetableFilterButton">Limpar</button>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import moment from 'moment'

export default {
  components: {
      Multiselect,
  },
  data () {
    return {
      date_attributes: [{key: 'today',highlight: true,dates: new Date()}],
      helpForm: new Form({params: []}),
      num_fiscal: '',
      num_controle: '',
      chave_cte: '',
      num_fiscal_cte: '',
      tom_nome: '',
      tom_ie: '',
      tom_cnpj: '',
      dt_inicio: '',
      dt_fim: '',
      optionsLivStatus: [],
      status: [],
      data_filter: []
    }
  },
  mounted() {
      this.getStatus();
    },
  methods: {
      doFilter () {
          this.$store.commit('setVuetableFilterButton', true);
          this.dt_inicio = this.formatDateSubmit(this.dt_inicio);
          this.dt_fim = this.formatDateSubmit(this.dt_fim);
          this.data_filter = {num_fiscal: this.num_fiscal,
                              num_controle: this.num_controle,
                              chave_cte: this.chave_cte,
                              num_fiscal_cte: this.num_fiscal_cte,
                              tom_nome: this.tom_nome,
                              tom_ie: this.tom_ie,
                              tom_cnpj: this.tom_cnpj,
                              dt_inicio: this.dt_inicio,
                              dt_fim: this.dt_fim,
                              status: this.status}
          this.$events.fire('filter-set', this.data_filter);
      },
      resetFilter () {
        this.num_fiscal = '';  // clear the text in text input
        this.num_controle = '';
        this.num_fiscal_cte = '';
        this.tom_ie = '';
        this.tom_nome = '';
        this.tom_cnpj = '';
        this.dt_inicio = '';
        this.dt_fim = '';
        this.status = '';
        this.$events.fire('filter-reset');
      },
      formatDateSubmit (value, fmt = 'DD/MM/YYYY') {
          return (value == null || value == "")
            ? ''
            : moment(value, 'YYYY/MM/DD HH:mm').format(fmt)
      },
      getStatus() {
          this.helpForm.params = { tabela: 'fatura',
                                  coluna: 'status' };

          this.helpForm.get('/api/listitemvalor/jsonlist').then(response =>
          {
              new ReturnApi(response, this, true, false, false);
              response.items.forEach((obj)=>
              {
                  this.optionsLivStatus.push({ label: obj.descr, value: obj.valor })
              });
          })
          .catch(errors =>
          {
              new ReturnApi(errors, this, true, false, false)
          });
      },
      formatTypedDate: function (dateString)
      {
         let result = dateString.split('/')
         return result[2] + '-' + result[1] + '-' + result[0] + 'T00:00:00-03:00'
      }
  },
  computed: {
    vuetableFilterButton: {
      get () {
        return this.$store.state.vuetable.filterButton;
      },
     },
     fieldDynamic: {
         get() {
             if(this.$store.getters.bcliente_active.cd_bcliente=='85'||this.$store.getters.bcliente_active.cd_bcliente=='1512')
             {
                 return false;
             }
             else
             {
                 return true;
             }
         }
     },
    }
}
</script>
